module.exports = __webpack_public_path__ + "img/2025-09-19d_5.4606d049.jpg";